import { forwardRef } from 'react';

interface IncidentIconProps extends React.SVGProps<SVGSVGElement> {
  size?: 'small' | 'medium' | 'large';
}

const ICON_SIZES = {
  small: 20,
  medium: 24,
  large: 32,
};

const IncidentIcon = forwardRef<SVGSVGElement, IncidentIconProps>(
  ({ size = 'medium', ...props }, ref) => {
    const iconSize = ICON_SIZES[size];

    return (
      <svg
        id='add_road-24px'
        xmlns='http://www.w3.org/2000/svg'
        width={iconSize}
        height={iconSize}
        viewBox='0 0 24 24'
        ref={ref}
        {...props}
      >
        <g id='Group_339' data-name='Group 339'>
          <rect
            id='Rectangle_7'
            data-name='Rectangle 7'
            width='24'
            height='24'
            fill='rgba(255,255,255,0.87)'
            opacity='0'
          />
        </g>
        <g id='Group_341' data-name='Group 341'>
          <g id='Group_340' data-name='Group 340'>
            <rect
              id='Rectangle_8'
              data-name='Rectangle 8'
              width='2'
              height='6'
              transform='translate(18 4)'
            />
            <rect
              id='Rectangle_9'
              data-name='Rectangle 9'
              width='2'
              height='16'
              transform='translate(4 4)'
            />
            <rect
              id='Rectangle_10'
              data-name='Rectangle 10'
              width='2'
              height='4'
              transform='translate(11 4)'
            />
          </g>
        </g>
        <path
          id='Path_40'
          data-name='Path 40'
          d='M21.723,10.732A1.112,1.112,0,0,0,20.647,10H12.673a1.127,1.127,0,0,0-1.087.732L10,15.29l.011,6.111a.8.8,0,0,0,.765.8h.688a.828.828,0,0,0,.754-.843V19.982h8.873v1.375a.837.837,0,0,0,.765.843h.677a.8.8,0,0,0,.765-.8l.011-1.519V15.29Zm-9.05.377h7.974l1.142,3.327H11.531Zm-.455,6.655a1.109,1.109,0,1,1,1.109-1.109A1.112,1.112,0,0,1,12.218,17.764Zm8.873,0A1.109,1.109,0,1,1,22.2,16.655,1.112,1.112,0,0,1,21.091,17.764Z'
          transform='translate(0.046 1.375)'
        />
      </svg>
    );
  }
);

export default IncidentIcon;
